import { ConversationMessage } from "./graph";

export interface MailAttachment {
  filename: string;
  contentType: string;
  contentBytes: string;
  supported: boolean;
  scanned: boolean;
  included: boolean;
  source: "mail" | "local";
  text?: string;
  erreur?: string;
}

export interface MailData {
  subject: string;
  from: string;
  date: string;
  body: string;
  thread: ConversationMessage[];
  attachments: MailAttachment[];
  userEmail: string;
  graphToken?: string;
}

export let mailData: MailData = {
  subject: "",
  from: "",
  date: "",
  body: "",
  thread: [],
  attachments: [],
  userEmail: "",
};

export function setMailData(data: MailData): void {
  mailData = data;
}
